module.exports = __webpack_public_path__ + "static/logo_face-f2ed51af61ce28df57063c2b8ef464db.png";